import { useEffect, useRef } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GlobalBottomSheet, {
  GlobalBottomSheetRef
} from "src/components/GlobalBottomSheet";
import GlobalPopupConfirm, {
  GlobalPopupConfirmRef
} from "src/components/GlobalPopupConfirm";
import LoadingModal from "src/components/LoadingModal";
import BottomSheetService from "src/utils/BottomSheetService";
import PopupService from "src/utils/PopupService";

import "./app.css";
import LoadingPage from './components/loadingPage/loadingPage';
import MainLayout from "./layouts/Main";
import ProvidersCheckLoading from "./providers/checkLoadingProvider";
import { RoutesWithAuth, RoutesWithoutAuth } from "./routes";

function App() {
  PopupService.instance = useRef<GlobalPopupConfirmRef>(null);
  BottomSheetService.instance = useRef<GlobalBottomSheetRef>(null);

  const _handleRNMessage = (message) => {
    alert("Message from RN: " + JSON.stringify(message.data));
  };

  useEffect(() => {
    document.addEventListener("reactnative_message", _handleRNMessage);
    return () => {
      document.removeEventListener("reactnative_message", _handleRNMessage);
    };
  }, []);

  return (
    <ProvidersCheckLoading>
      <div className="theme-default app">
        <ToastContainer />
        <Router>
          <MainLayout>
            <Routes>
              {RoutesWithAuth.map((route) => (
                <Route
                  path={route.path}
                  key={route.path}
                  element={<route.Component />}
                ></Route>
              ))}
              {RoutesWithoutAuth.map((route) => (
                <Route
                  path={route.path}
                  key={route.path}
                  element={<route.Component />}
                ></Route>
              ))}
              {/* <Route path={PATH.OTHER} component={Home}></Route> */}
            </Routes>
          </MainLayout>
        </Router>
        <GlobalPopupConfirm ref={PopupService.instance} />
        <GlobalBottomSheet ref={BottomSheetService.instance} />
        <LoadingModal />
        <LoadingPage/>
      </div>
    </ProvidersCheckLoading>
  );
}

export default App;
